import Component from "react-pure-render/component";
import React from "react";
import { FormattedHTMLMessage } from "react-intl";

export default class Wysiwyg extends Component {
  constructor(props) {
    super(props);
    this.editor = null;
  }

  componentDidMount() {
    const { actions, feature, uid, field, id } = this.props;
    const self = this;

    window.CKEDITOR.DEFAULT_AE_EMBED_URL_TPL =
      "//example.com/api/oembed?url={url}&callback={callback}&api_key=4594ab8b1d5e54e98b9804";
    window.CKEDITOR.DEFAULT_AE_EMBED_WIDGET_TPL = "{url}";
    this.editor = window.AlloyEditor.editable(id, {
      toolbars: {
        add: {
          buttons: ["image", "hline", "table", "embed", "iframe"]
        },
        styles: {
          selections: [
            {
              name: "text",
              buttons: [
                {
                  name: "styles",
                  cfg: {
                    styles: [
                      {
                        name: "Nagłówek 1",
                        style: {
                          element: "h1"
                        }
                      },
                      {
                        name: "Nagłówek 2",
                        style: {
                          element: "h2"
                        }
                      },
                      {
                        name: "Big",
                        style: {
                          element: "big"
                        }
                      },
                      {
                        name: "Small",
                        style: {
                          element: "small"
                        }
                      },
                      {
                        name: "Code",
                        style: {
                          element: "code"
                        }
                      }
                    ]
                  }
                },
                "bold",
                "italic",
                "underline",
                "strike",
                "paragraphLeft",
                "paragraphCenter",
                "paragraphRight",
                "paragraphJustify",
                "link",
                "ul",
                "ol",
                "quote"
              ],
              test: window.AlloyEditor.SelectionTest.text
            },
            {
              name: "image",
              buttons: ["imageLeft", "imageCenter", "imageRight"],
              test: window.AlloyEditor.SelectionTest.image
            },
            {
              name: "table",
              buttons: [
                "tableHeading",
                "tableRow",
                "tableColumn",
                "tableCell",
                "tableRemove"
              ],
              test: window.AlloyEditor.SelectionTest.table
            }
          ]
        }
      }
    });

    this.editor.get("nativeEditor").on("imageAdd", function(event) {
      actions.setEntityField(
        feature,
        uid,
        field,
        self.editor.get("nativeEditor").getData()
      );
    });

    this.editor.get("nativeEditor").on("change", function(event) {
      actions.setEntityField(
        feature,
        uid,
        field,
        self.editor.get("nativeEditor").getData()
      );
    });

    this.editor.get("nativeEditor").on("ariaUpdate", function(event) {
      actions.setEntityField(
        feature,
        uid,
        field,
        self.editor.get("nativeEditor").getData()
      );
    });
  }

  componentWillUnmount() {
    this.editor.destroy();
  }

  render() {
    const { content, id } = this.props;
    const minHeight = 25;

    return (
      <div
        style={{ minHeight }}
        id={id}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/wysiwyg.react.js